<template>
<div id="OccupyOrderList" class="border-container" v-if="$auth('order.list')">
    <a-spin :spinning="loading" v-if="loading" class='loading-incontent'></a-spin>
    <div class="title-container">
        <div class="title-area">
            <span v-if="type === TYPE.CHARGE">{{ title }}</span>
            <span v-else>{{ $Filter.occupyOrderTypeFilter(type, 'text') }}占用费订单列表</span>
        </div>
        <div class="btn-area"></div>
    </div>
    <div class="list-container">
        <div class="operate-container">
            <div class="search-area" :class="[showDown ? 'multi-line' : 'one-line', $auth('ADMIN') ? 'admin' : 'sp']">
                <a-col :xl="16" :md="24" class="search-item time-range-select" v-if='type === TYPE.TANK'>
                    <div class="key"><span>开始时间:</span></div>
                    <div class="value">
                        <SelectTime v-model="searchTime.begin" @change='handleTimeChange("begin")'/>
                    </div>
                </a-col>
                <a-col :xl="16" :md="24" class="search-item time-range-select" v-if='[TYPE.GATE, TYPE.CHARGE].includes(type)'>
                    <div class="key"><span>创建时间:</span></div>
                    <div class="value">
                        <SelectTime v-model="searchTime.create" @change='handleTimeChange("create")'/>
                    </div>
                </a-col>
                <a-col :xl="8" :lg='12' :md="24"  class="search-item">
                    <div class="key"><span>订单号:</span></div>
                    <div class="value">
                        <a-input placeholder="请输入" v-model="searchForm.sn" @keydown.native.enter="handleSearch" />
                    </div>
                </a-col>
                <!-- <a-col :xl="8" :lg='12' :md="24"  class="search-item">
                    <div class="key"><span>用户昵称:</span></div>
                    <div class="value">
                        <a-input placeholder="请输入" v-model="searchForm.nickname" @keydown.native.enter="handleSearch" />
                    </div>
                </a-col> -->
                <a-col :xl="8" :lg='12' :md="24"  class="search-item">
                    <div class="key"><span>用户手机:</span></div>
                    <div class="value">
                        <a-input placeholder="请输入" v-model="searchForm.user_phone" @keydown.native.enter="handleSearch" />
                    </div>
                </a-col>
                <a-col :xl="8" :lg='12' :md="24"  class="search-item">
                    <div class="key"><span>车牌号:</span></div>
                    <div class="value">
                        <a-input placeholder="请输入完整车牌号" v-model="searchForm.license_plate_number" @keydown.native.enter="handleSearch" />
                    </div>
                </a-col>
                <a-col :xl="8" :lg='12' :md="24"  class="search-item value-select" v-if="$auth('ADMIN')">
                    <div class="key"><span>运营商:</span></div>
                    <div class="value">
                        <SelectOperator v-model="searchForm.operator_id" @changed="handleSearch"/>
                    </div>
                </a-col>
                <a-col :xl="8" :lg='12' :md="24"  class="search-item value-select">
                    <div class="key"><span>片区:</span></div>
                    <div class="value">
                        <a-select v-model="searchForm.org_id" show-search option-filter-prop="children" allow-clear @changed="handleSearch"
                            :disabled="!searchForm.operator_id"  :placeholder="searchForm.operator_id ? '请选择' : '请先选择运营商'">
                            <a-select-option v-for="item of orgList" :key="item.id" :value="item.id" :label="item.name">{{item.name}}</a-select-option>
                        </a-select>
                    </div>
                </a-col>
                <template v-if='type !== TYPE.GATE'>
                    <a-col :xl="8" :lg='12' :md="24"  class="search-item value-select">
                        <div class="key"><span>充电站:</span></div>
                        <div class="value">
                            <a-select v-model="searchForm.station_id" @changed="handleSearch" show-search option-filter-prop="children" allow-clear
                                :disabled="!searchForm.operator_id"  :placeholder="searchForm.operator_id ? '请选择' : '请先选择运营商'">
                                <a-select-option v-for="item of stationList" :key="item.id" :value="item.id" :label="item.name">{{item.name}}</a-select-option>
                            </a-select>
                        </div>
                    </a-col>
                    <a-col :xl="8" :lg='12' :md="24"  class="search-item">
                        <div class="key"><span>厂商UID:</span></div>
                        <div class="value">
                            <a-input placeholder="请输入" v-model="searchForm.socket_uid" @keydown.native.enter="handleSearch" />
                        </div>
                    </a-col>
                </template>
                <template v-if='type === TYPE.TANK'>
                    <a-col :xl="8" :lg='12' :md="24"  class="search-item">
                        <div class="key"><span>网关UID:</span></div>
                        <div class="value">
                            <a-input placeholder="请输入" v-model="searchForm.gateway_uid" @keydown.native.enter="handleSearch" />
                        </div>
                    </a-col>
                </template>
                <a-col :xl="8" :lg='12' :md="24"  class="search-item">
                    <div class="key"><span>商户单号:</span></div>
                    <div class="value">
                        <a-input placeholder="请输入" v-model="searchForm.outer_sn" @keydown.native.enter="handleSearch" />
                    </div>
                </a-col>
                <a-col :xl="16" :md="24" class="search-item time-range-select">
                    <div class="key"><span>结算时间:</span></div>
                    <div class="value">
                        <SelectTime v-model="searchTime.clearing" @change='handleTimeChange("clearing")'/>
                    </div>
                </a-col>
            </div>
            <div class="btn-area">
                <a-button type="link" @click="showDown = !showDown">
                    <span>
                        {{ showDown ? '收起' : '展开'}}
                        <a-icon type="down" class="operate-icon" :class="{'up': showDown}"/>
                    </span>
                </a-button>
                <a-button type="primary" @click="handleSearch">查询</a-button>
                <a-button @click="handleSearchReset">重置</a-button>
            </div>
        </div>
        <div class="table-container">
            <a-table :columns="$Filter.tableFieldsFilter(tableColumns, userType)" :data-source="tableData"
                :row-key="record => record.id" :pagination='false' :scroll="{ x: true, }">

                <template> <!-- 过滤ICON -->
                    <div slot="filter_icon" class="filter_icon" >
                        <i class="icon i-dropdown"/>
                    </div>
                </template>
                <template> <!-- 过滤下拉框 -->
                    <div slot="status_filter" class="filter_dropdown">
                        <div v-for="(item, index) of statusList" :key="index" @click="handleFilterChange('status', item.value)"
                            class="filter_dropdown_item" :class="{'active': searchForm.status == item.value}">
                            {{item.text}}
                        </div>
                    </div>
                    <div slot="pay_method_filter" class="filter_dropdown">
                        <div v-for="(item, index) of payMethodList" :key="index" @click="handleFilterChange('pay_method', item.value)"
                            class="filter_dropdown_item" :class="{'active': searchForm.pay_method == item.value}">
                            {{item.text}}
                        </div>
                    </div>
                    <div slot="finish_code_filter" class="filter_dropdown">
                        <div v-for="(item, index) of finishCodeList" :key="index" @click="handleFilterChange('finish_code', item.value)"
                            class="filter_dropdown_item" :class="{'active': searchForm.finish_code == item.value}">
                            {{item.text}}
                        </div>
                    </div>
                    <div slot="clearing_status_filter" class="filter_dropdown">
                        <div v-for="(item, index) of clearingStatusList" :key="index" @click="handleFilterChange('clearing_status', item.value)"
                            class="filter_dropdown_item" :class="{'active': searchForm.clearing_status == item.value}">
                            {{item.text}}
                        </div>
                    </div>
                    <!--结算后退款状态筛选 -->
                    <div slot="refund_status_filter" class="filter_dropdown">
                        <div v-for="(item, index) of refundStatusList" :key="index" @click="handleFilterChange('refund_status', item.value)"
                            class="filter_dropdown_item" :class="{'active': searchForm.refund_status == item.value}">
                            {{item.text}}
                        </div>
                    </div>
                </template>

                <!-- 订单号 -->
                <template slot="sn" slot-scope="text, record">
                    <a-tooltip :title="text" destroy-tooltip-on-hide>
                        <router-link v-if="$auth('order.detail')" target="_blank" :to="getRouterLink('detail', record)">
                            <span class="text-ellipsis" style="max-width: 160px;">{{ text }}</span>
                        </router-link>
                        <span v-else>{{text}}</span>
                    </a-tooltip>
                </template>
                <!-- 通用 超出隐藏带tooltip-->
                <template slot="name" slot-scope="text">
                    <a-tooltip :title="text" destroy-tooltip-on-hide>
                        <span class="text-ellipsis" style="maxWidth: 150px;">{{text}}</span>
                    </a-tooltip>
                </template>
                <!-- 车牌号-->
                <template slot="license_plate_number" slot-scope="text">
                    <a-tooltip :title="text" destroy-tooltip-on-hide v-if="text">
                        <span class="text-ellipsis" style="maxWidth: 150px;">{{text}}</span>
                    </a-tooltip>
                    <span v-else>{{text || '-'}}</span>
                </template>
                <!-- 占位时长 -->
                <template slot="occupy_time" slot-scope="text, record">
                    {{  $Filter.occupyTimeFilter(record.begin_time, record.end_time, type === TYPE.CHARGE ? true : false) }}
                </template>
                <!-- 充电设备信息 -->
                <template slot="socket_info" slot-scope="text, record">
                    <div> {{ record.socket_uid + "-" + record.node_index + "-" + (record.port_index + 1) }}</div>
                </template>
                <!-- 道闸设备信息 -->
                <template slot="gate_info" slot-scope="text, record">
                    <div> {{ record.socket_uid + "-" + record.node_index + "-" + PORT_NAME[record.port_index + 1] }}</div>
                </template>
                <!-- 状态 -->
                <template slot="status" slot-scope="text, record">  <!-- 订单状态 -->
                    <!-- 充电占位 保证金不够或没有支付保证金但产生占位费用，占位订单状态为"待支付" -->
                    <!-- <span class="item-status grey" v-if="type === TYPE.CHARGE && record.pursue_order_status === PURSUE_STATUS.WAIT_PAY"><i class='icon i-point'/>待支付</span>
                    <span class="item-status" v-else :class="$Filter.occupyOrderStatusFilter(text, 'color')">
                        <i class='icon i-point'/>{{ $Filter.occupyOrderStatusFilter(text) }}
                    </span> -->
                    <span class="item-status" :class="$Filter.occupyOrderStatusFilter(text, 'color')">
                        <i class='icon i-point'/>{{ $Filter.occupyOrderStatusFilter(text) }}
                    </span>
                </template>

                <!-- 结束原因 -->
                <template slot="finish_code" slot-scope="text, record"> <!-- 结束原因 -->
                    <span v-if="isFinish(record.status)">{{ $Filter.orderFinishCodeFilter(text, 'OCCUPY') }}</span>
                    <template v-else>-</template>
                </template>

                <!-- 支付金额 -->
                <template slot="price" slot-scope="text">
                    <span class="bold">￥{{ $Filter.moneyFilter(text) }}</span>
                </template>

                <!-- 实际收费 -->
                <template slot="charge" slot-scope="text, record">
                    <template v-if="isFinish(record.status)">
                        <span class="bold" >￥{{ $Filter.moneyFilter(text) }}</span>
                    </template>
                    <template v-else>-</template>
                </template>

                <!-- 结算金额 -->
                <template slot="clearing_money" slot-scope="text">
                    <span class="bold">{{$Filter.moneyFilter(text, 2)}}</span>
                </template>

                <!-- 结算状态 -->
                <template slot="clearing_status" slot-scope="text, record">
                    <span :style="$Filter.clearingStatusFilter(text, 'color')" v-if="$Filter.isPayByCash(record.pay_method, 'occupy')">
                        {{ $Filter.clearingStatusFilter(text) }}
                    </span>
                    <template v-else>-</template>
                </template>


                <!-- 结算后退款金额 -->
                <template slot="refund_money" slot-scope="text">
                    <span class="bold">{{$Filter.moneyFilter(text, 2)}}</span>
                </template>

                <!-- 结算后退款状态 -->
                <template slot="refund_status" slot-scope="text">
                    <span :style="$Filter.orderRefundStatusFilter(text, 'color')" v-if="!!text">
                        {{ $Filter.orderRefundStatusFilter(text) }}
                    </span>
                    <template v-else>-</template>
                </template>

                <!-- 付款方式 -->
                <template slot="pay_method" slot-scope="text">
                    <i class="icon" :class="$Filter.occupyOrderPayMethodFormat(text, 'icon')"></i>
                    {{ $Filter.occupyOrderPayMethodFormat(text) }}
                </template>

                <!-- 通用 时间 -->
                <template slot="time" slot-scope="text">
                    {{ $Filter.timeFilter(text, 6)}}
                </template>

                <template slot="charge_order" slot-scope="text, record">
                    <a-tooltip :title="text" destroy-tooltip-on-hide>
                        <router-link v-if="$auth('order.detail') && record.order_id" target="_blank" :to="getRouterLink('charge', record.order_id)">
                            <span class="text-ellipsis" style="max-width: 160px;">{{ record.order ? record.order.sn : '' }}</span>
                        </router-link>
                        <span v-else>{{ record.order ? record.order.sn : '' }}</span>
                    </a-tooltip>
                </template>
                <template slot="pursue_order" slot-scope="text, record">
                    <a-tooltip :title="text" destroy-tooltip-on-hide>
                        <router-link v-if="$auth('order.detail') && record.pursue_order_id" target="_blank" :to="getRouterLink('pursue', record.pursue_order_id)">
                            <span class="text-ellipsis" style="max-width: 160px;">{{ record.pursue_order_sn }}</span>
                        </router-link>
                        <span v-else>{{ record.pursue_order_sn }}</span>
                    </a-tooltip>
                </template>
            </a-table>
        </div>
        <div class="paging-container">
            <a-pagination
                show-quick-jumper
                show-less-items
                :show-total="total => `共 ${total} 条记录`"
                :hide-on-single-page='false'
                :total="total"
                :current="currPage"
                :default-page-size='20'
                @change="pageChange"
            />
        </div>
    </div>
</div>
</template>

<script>
import Core from '../../core';
import moment from 'moment';
const LOGIN_TYPE = Core.Const.LOGIN_TYPE;
const TYPE = Core.Const.OCCUPY.TYPE
const STATUS = Core.Const.OCCUPY.STATUS

const PURSUE_STATUS = Core.Const.PURSUE.STATUS

export default {
	name: 'OccupyOrderList',
	components: {},
	props: {},
	data() {
		return {
            PURSUE_STATUS,

            userType: Core.Data.getLoginType(),
            PORT_NAME: Core.Const.DEVICE.PORT_NAME.NORMAL,
            LOGIN_TYPE,
            TYPE,
			loading: true,
			// 分页
			currPage: 1,
			total: 0,

            type: 0, // 页面类型
            title: '',  // 页面标题

			// 搜索
			showDown: false,
			searchForm: {
				sn: '', // 订单号
                outer_sn: '', // 商户单号

				socket_uid: '', // 设备UID
				gateway_uid: '', // 网关UID

				user_id: '',    // 用户ID
				nickname: '',   // 用户昵称
				user_phone: '', // 用户手机号
                license_plate_number: '', // 车牌号

				status: '',      // 订单状态
				pay_method: '',  // 支付方式
				finish_code: '', // 结束原因
				clearing_status: '', // 结算状态

				operator_id: undefined,
				org_id: undefined,
				station_id: undefined,
			},
            searchTime: {
                clearing: {},
                begin: {
                    begin_time: moment().subtract(6, 'd').startOf('D').unix(),
                    end_time: moment().endOf('D').unix(),
                },
                create: {
                    begin_time: moment().subtract(30, 'd').startOf('D').unix(),
                    end_time: moment().endOf('D').unix(),
                },
            },
			stationList: [],
			orgList:[],

            // 表格
            tableData: [],

            statusList: Object.values(Core.Const.OCCUPY.STATUS_MAP),
            finishCodeList: Object.values(Core.Const.OCCUPY.FINISH_CODE_MAP),
            clearingStatusList: Core.Const.CLEARING.STATUS_LIST,

            refundStatusList: Core.Const.ORDER.REFUND_STATUS_LIST,
		}
	},
	computed: {
        tableColumns() {
            let tableColumns = [
                { title: '订单号', dataIndex: 'sn', scopedSlots: { customRender: 'sn' }, },
                { title: '占位时长', dataIndex: 'occupy_time', scopedSlots: { customRender: 'occupy_time' }},
                { title: '开始时间', dataIndex: 'begin_time', scopedSlots: { customRender: 'time' }, width: '180px', },
                { title: '订单状态', dataIndex: 'status', key: 'status', slots: { filterIcon: 'filter_icon',}, scopedSlots: { customRender: 'status', filterDropdown: 'status_filter'}, },
                { target_type: [TYPE.GATE], title: '结束原因', dataIndex: 'finish_code', key: 'finish_code', slots: { filterIcon: 'filter_icon',}, scopedSlots: { customRender: 'finish_code', filterDropdown: 'finish_code_filter'}, },
                { title: '结束计费时间', dataIndex: 'end_time', scopedSlots: { customRender: 'time' }, width: '190px', },
                { title: '支付金额', dataIndex: 'price', scopedSlots: { customRender: 'price' }, width: '100px', },
                { title: '付款方式', dataIndex: 'pay_method', slots: { filterIcon: 'filter_icon'}, scopedSlots: { customRender: 'pay_method', filterDropdown: 'pay_method_filter'}, },
                { title: '结算状态', key: 'clearing_status', dataIndex: 'clearing_status', slots: { filterIcon: 'filter_icon'}, scopedSlots: { customRender: 'clearing_status', filterDropdown: 'clearing_status_filter'}, },
                { title: '用户手机号', dataIndex: 'user_phone', scopedSlots: { customRender: 'name' }, },
                { title: '车牌号', dataIndex: 'license_plate_number', scopedSlots: { customRender: 'license_plate_number' }, },
                { title: '运营商', dataIndex: 'operator_name', scopedSlots: { customRender: 'name' }, role: [LOGIN_TYPE.ADMIN], },
                { title: '片区名称', dataIndex: 'org_name', scopedSlots: { customRender: 'name' }, },

                { target_type: [TYPE.TANK], title: '充电站名称', dataIndex: 'station_name', scopedSlots: { customRender: 'name' }, },
                { title: '厂商UID/设备号/插口号', dataIndex: 'socket_info', scopedSlots: { customRender: 'socket_info' }, },
                { target_type: [TYPE.GATE], title: '关联充电订单', dataIndex: 'charge_order_sn', scopedSlots: { customRender: 'charge_order' }, },
                { target_type: [TYPE.GATE], title: '关联追款订单', dataIndex: 'pursue_order_sn', scopedSlots: { customRender: 'pursue_order' }, },

                { title: '实际收费', dataIndex: 'charge', scopedSlots: { customRender: 'charge' }, width: '100px', },
                { title: '打款金额', dataIndex: 'clearing_money', scopedSlots: { customRender: 'clearing_money' }, width: '100px', },
                
                { title: '结算后退款金额', dataIndex: 'refund_money', scopedSlots: { customRender: 'refund_money' }, width: '100px', },
                { title: '结算后退款状态', key: 'refund_status', dataIndex: 'refund_status', slots: { filterIcon: 'filter_icon'}, scopedSlots: { customRender: 'refund_status', filterDropdown: 'refund_status_filter'}, },

                { title: '创建时间', dataIndex: 'create_time', scopedSlots: { customRender: 'time' }, width: '190px', },
                { title: '结算时间', dataIndex: 'clearing_time', scopedSlots: { customRender: 'time' }, width: '190px', },
            ];
            return tableColumns.filter(i => !i.target_type || i.target_type.includes(this.type))
        },
        payMethodList() {
            return Object.values(Core.Const.OCCUPY.PAY_METHOD_MAP).filter(i => !i.type || i.type.includes(this.type))
        }
    },
    mounted() {
        this.type = this.$route.meta.type;
        this.title = this.$route.meta.title;
        if (!this.$auth('ADMIN')) {
            this.searchForm.operator_id = Core.Data.getUser().id;
        }
    },
	watch: {
		'searchForm.operator_id': function(newVal) {
            if (newVal) {
                this.getOrgList(newVal);
                this.getStationList(newVal);
            } else {
				this.orgList = [];
				this.stationList = [];
            }
            this.searchForm.org_id = undefined;
            this.searchForm.station_id = undefined;
        },
        'searchForm.org_id': function(newVal) {
            if (newVal) {
                this.getStationListByOrg(newVal);
            } else if (this.searchForm.operator_id) {
                this.getStationList(this.searchForm.operator_id);
            } else {
				this.stationList = [];
            }
            this.searchForm.station_id = undefined;
        },
		$route: {
            deep: true,
            immediate: true,
            handler(newRoute) {
                console.log('newRoute:', newRoute)
                this.type = newRoute.meta.type;
                this.title = newRoute.meta.title;
                this.handleSearchReset();
            }
        }
	},
	methods: {
        isFinish(status) {
            switch (status) {
                case STATUS.SUCCESS:
                    if (this.type === TYPE.TANK) { return true }
                    break;
                case STATUS.FINISH:
                case STATUS.WAITING_REFUND:
                case STATUS.WAITING_REFUND_NEW:
                case STATUS.COMPLETE_REFUND:
                    return true
                default:
                    return false
            }

        },
        getRouterLink(type, item = {}) {
			switch (type) {
                case 'detail':
                    return {
                        path: `/occupy-order/${Core.Filter.occupyOrderTypeFilter(this.type, 'key')}-order-detail`,
                        query: { id: item.id },
                    }
                case 'charge':
                    return {
                        path: `/charing-order/order-detail`,
                        query: { id: item },
                    }
                case 'pursue':
                    return {
                        path: `/occupy-order/pursue-order-detail`,
                        query: { id: item },
                    }
			}
		},
		pageChange(page) {
			this.currPage = page
			this.getTableData()
		},
        handleFilterChange(key, value) {
            this.searchForm[key] = value
            this.handleSearch()
        },
		handleSearch() {  // 搜索
            this.pageChange(1);
        },
        handleSearchReset() {  // 重置搜索
            Object.assign(this.searchForm, this.$options.data().searchForm)
            Object.assign(this.searchTime, this.$options.data().searchTime)
            if (this.$auth('OPERATOR')) {
                this.searchForm.operator_id = Core.Data.getUser().id
            }
            this.pageChange(1);
		},
        // 计算时间跨度是否大于31天
        handleTimeChange(key) {
            let { begin_time, end_time } = this.searchTime[key]
            let diff = Core.Util.diffOfTime(begin_time, end_time) + 1
            if (diff > 31) {
                this.$message.warning('请将日期查询范围控制在31天内')
                return true
            }
            return false
        },

		getTableData() { // 获取表格数据
            if (this.handleTimeChange('create') || this.handleTimeChange('clearing')) { return }

			this.loading = true
            let form = Core.Util.deepCopy(this.searchForm);
            let time = Core.Util.deepCopy(this.searchTime);

            let { begin_time = '', end_time = '' } = time.begin
            let { begin_time: create_begin_time = '', end_time: create_end_time = '' } = time.create
            let { begin_time: clearing_begin_time = '', end_time: clearing_end_time = '' } = time.clearing

            if (end_time === begin_time && end_time) { end_time++ }
            if (create_end_time === create_begin_time && create_end_time) { create_end_time++ }
            if (clearing_end_time === clearing_begin_time && clearing_end_time) { clearing_end_time++ }

            let create_time = this.type === TYPE.TANK ? { begin_time, end_time } : { create_begin_time, create_end_time }
			Core.Api.OccupyOrder.list({
				type: this.type,
				page: this.currPage,
				...form,
                ...create_time,
                license_plate_number: form.license_plate_number.toLocaleUpperCase(),
				clearing_begin_time,
                clearing_end_time,
			}).then(res => {
				console.log("getTableData res", res)
				this.total = res.count
				this.tableData = res.list
                this.loading = false
			}).catch(err => {
                this.loading = false
				console.log("getTableData err", err)
			})
		},
		getOrgList(operatorId) { // 获取选择用 片区 列表
			Core.Api.Org.listName(operatorId).then(res => {
				console.log("getOrgList res", res)
				this.orgList = res.org_list
			})
		},
		getStationList(operatorId) { // 获取选择用 充电站 列表
			Core.Api.Station.listAll(operatorId).then(res => {
				console.log("getStationList res", res)
				this.stationList = res.station_list
			})
        },
        async getStationListByOrg(org_id) { // 获取选择用 充电站 列表
            if (!org_id) {
                this.stationList = [];
                return
            }
            let page = 1;
            let total = 0;
            this.stationList = [];

			await Core.Api.Station.listByOrgId(page,org_id).then(res => {
                this.stationList = res.station_list
                total = res.count
            })
            for (let i = 20; i < total; i = i+20) {
                page++
                await Core.Api.Station.listByOrgId(page,org_id).then(res => {
                    this.stationList = [...this.stationList,...res.station_list]
                })
            }
            console.log("getStationList res", this.stationList)
        },
	}
};
</script>

<style lang="scss" scoped>
#OccupyOrderList {
    position: relative;
	.operate-container {
        .btn-area {
            width: 164px;
            .operate-icon {
                transition: all .3s linear;
                &.up {
                    transform: rotate(180deg);
                }
            }
        }
        .search-area {
            width: calc(100% - 165px);
            min-width: 300px;
            overflow: hidden;
            transition: height .3s ease;
            padding-top: 2px;
            .search-item {
                .value {
                    min-width: 180px;
                }
            }
            &.one-line {
                height: 38px;
            }
            @media (min-width: 1200px) { // xl 一行三个
                &.multi-line.admin {
                    height: calc(38px * 4);
                }
                &.multi-line.sp {
                    height: calc(38px * 4);
                }
            }
            @media (max-width: 992px) { // lg以下 一行一个
                &.multi-line.admin {
                    height: calc(38px * 10);
                }
                &.multi-line.sp {
                    height: calc(38px * 9);
                }
            }
        }
    }
    .table-container {
        table span {
            display: inline-block;
        }
    }
}
</style>
